import React from 'react';
import PropTypes from 'prop-types';
import MProductPlacement from '../../molecules/_molecules.product-placement';
import MProductCompare from '../../molecules/_molecules.product-compare';

export default function OCompareDetail({
	product1,
	product2,
	onNewProduct,
	onRemoveProduct1,
	onRemoveProduct2,
}) {
	let product1Item = <MProductPlacement onClick={onNewProduct} />;
	let product2Item = <MProductPlacement onClick={onNewProduct} />;

	if (product1) {
		product1Item = (
			<MProductCompare
				title={product1.name}
				img={product1.featuredImage.url}
				description={product1.description}
				onClose={onRemoveProduct1}
			/>
		);
	}

	if (product2) {
		product2Item = (
			<MProductCompare
				title={product2.name}
				img={product2.featuredImage.url}
				description={product2.description}
				onClose={onRemoveProduct2}
			/>
		);
	}

	return (
		<section className="o-compare-detail">
			<div className="wrapper">
				{product1Item}
			</div>
			<div className="wrapper">
				{product2Item}
			</div>
		</section>
	);
}

OCompareDetail.propTypes = {
	product1: PropTypes.any.isRequired,
	product2: PropTypes.any,
	onNewProduct: PropTypes.func,
	onRemoveProduct1: PropTypes.func.isRequired,
	onRemoveProduct2: PropTypes.func,
};

OCompareDetail.defaultProps = {
	product2: undefined,
	onNewProduct: undefined,
	onRemoveProduct2: undefined,
};



// WEBPACK FOOTER //
// ./src/components/organisme/compare/_organisme.compare-detail.js